"use client";

import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/lib/api/me";
import { cmsKeys } from "@/lib/query-keys";

/**
 * Aktif oturum sahibinin profilini ve plan bilgisini getirir.
 * SuperAdminGuard, sidebar AccountChip ve dashboard her yerde aynı key'i
 * kullanır → tek HTTP turunu paylaşırlar.
 */
export function useMe() {
  return useQuery({
    queryKey: cmsKeys.me,
    queryFn: meApi.get,
    staleTime: 60_000,
    retry: false,
  });
}
